export default {
  'Resolution': '分辨率',
  'Frame rate': '幀率',
  'The higher the frame rate, the smoother the animation': '幀率越高，動畫越流暢。',
}